// import hooks
import { useState } from "react";
import { useTranslation } from "react-i18next";
import useWindowSize from "../../utils/custom-hooks/useWindowSize";

// import components
import ChangeBtn from "./ChangeBtn";
import SaveBtn from "./SaveBtn";

// import assets

// import data

const Email = ({ email, onHandleChange }) => {
    const [t] = useTranslation("global");
    const windowWidth = useWindowSize();
    // const [uemail, setEmail] = useState(email);

    const [showEdit, setShowEdit] = useState(false);
    return (
        <div className="account-email-container account-personal-item">
            {!showEdit ? (
                <div className="email-preview item-preview flex-between-row">
                    <div className="account-personal-txt">
                        <p className="ocean-p-grey">
                            {t("modals.signup.email")}
                        </p>
                        <p className="ocean-p ocean-p-700">{email}</p>
                    </div>
                    <ChangeBtn onHandleClick={() => setShowEdit(true)} />
                </div>
            ) : (
                <div
                    className={`account-personal-edit ${
                        windowWidth >= 992
                            ? "flex-between-row"
                            : "flex-center-col"
                    }`}
                >
                    <div className="label-input-div sign-up-form-field">
                        <label className="custom-modal-label">
                            {t("modals.signup.email")}
                        </label>
                        <input
                            type="text"
                            value={email}
                            onChange={(e) => onHandleChange(e.target.value)}
                            className="custom-modal-input"
                            placeholder={t("modals.signup.email")}
                        />
                    </div>
                    <SaveBtn onHandleClick={() => setShowEdit(false)} />
                </div>
            )}
        </div>
    );
};

export default Email;
